import { GET_TEAMS, GET_ZONE_TEAMS, SUCCESS, FAIL } from "../action_types";

const STATE_INIT = {
  isLoading: false,
  isUpdating: false,
  teams: [],
  zoneTeams: [],
  error: {},
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    case GET_TEAMS:
      return { ...state, isLoading: true };
    case `${GET_TEAMS}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        teams: [...payload],
      };
    case `${GET_TEAMS}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case GET_ZONE_TEAMS:
      return { ...state, isLoading: true };
    case `${GET_ZONE_TEAMS}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        zoneTeams: [...payload],
      };
    case `${GET_ZONE_TEAMS}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    default:
      return state;
  }
};
